//Do NOT edit this file. Update in package.json instead. Thank you!
export const ORGBRAIN_VERSION = '37.4.13';